module.exports = __webpack_public_path__ + "img/IMG_0424.1f4dfad5.jpg";